const index = () => {
  return (
    <div>
      <h1 className="m-0 mb-1 font-semibold text-display-xs">
        TeamWork Integration
      </h1>
    </div>
  )
}

export default index
